import React, { useState } from 'react'
import 'rc-slider/assets/index.css'
import 'react-input-range/lib/css/index.css'
import PropTypes from 'prop-types'
import TextAreaInput from 'common/TextAreaInput'
import { COMMENT_DRAWER_MODES } from './CommentDrawer.constant'
import CommentBoxActions from './CommentBoxActions'
const AVAIABLE_CHARACTER_TEXT = 'caracteres disponibles'
const CHARACTER_TEXT = 'caracteres'

const CommentBox = ({ 
  mode,
   maxLength,
    onSave, 
    onCancel,
     comment, }) => {
  const [inputCommentValue, setInputCommentValue] = useState(comment || '')
  const [avaiableCharacters, setAvaiableCharacters] = useState(
    maxLength - inputCommentValue?.length
    )
  const [disabledComment, setdisabledComment] = useState(
    mode === COMMENT_DRAWER_MODES.VIEW || mode === COMMENT_DRAWER_MODES.EDIT
  )

  const handleInputChange = event => {
    const newText = event?.target?.value ?? ''
    setInputCommentValue(newText)
    const charactersLeft = maxLength - newText.length
    setAvaiableCharacters(charactersLeft)
  }

  const handleOnSave = () => {
    onSave(inputCommentValue)
  }

  const handleEnabledComment = () => {
    setdisabledComment(false)
  }

  const avaiableCharactersMessage = `${avaiableCharacters} ${AVAIABLE_CHARACTER_TEXT}`
  const commentLengthMessage = `${inputCommentValue?.length} ${CHARACTER_TEXT}`
  return (
    <div className="comment-box">
      <div className="cont-comments">
        <div>
          <TextAreaInput
            rows="6"
            value={inputCommentValue}
            disabled={disabledComment}
            limit={maxLength}
            maxLength={maxLength}
            onChange={handleInputChange}
          />
          <div className="cont-buttons-comments">
            <div className="avaiable-character-text">
              <div>
                {mode === COMMENT_DRAWER_MODES.VIEW
                  ? commentLengthMessage
                  : avaiableCharactersMessage}
              </div>
            </div>
            <div className='cont-actions-comments'>
              {mode !== COMMENT_DRAWER_MODES.VIEW && (
                <CommentBoxActions
                  mode={mode}
                  onSave={handleOnSave}
                  onCancel={onCancel}
                  handleEnabledComment={handleEnabledComment}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CommentBox.propTypes = {
  mode: PropTypes.string,
  maxLength: PropTypes.number,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
   comment: PropTypes.string,
}

CommentBox.defaultProps = {
  mode: COMMENT_DRAWER_MODES.EDIT,
  maxLength: 250,
  onSave: () => {},
  onCancel: () => {},
  comment: '',
}

export default CommentBox
